import { cn } from '@/lib/utils';
import React from 'react';

interface SectionHeaderProps {
    title: string;
    description?: string;
    /** Rendered flush right of the title/description, e.g. a "New X" button. */
    action?: React.ReactNode;
    level?: 'page' | 'section';
    className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
    title,
    description,
    action,
    level = 'page',
    className
}) => (
    <div
        className={cn(
            action && 'flex flex-wrap justify-between items-start gap-4',
            className
        )}
    >
        <div className={cn('min-w-0', action && 'flex-1 basis-64')}>
            <h3
                className={cn(
                    'font-medium text-foreground',
                    level === 'page' ? 'text-xl' : 'text-(length:--fs-title)',
                    'leading-6'
                )}
            >
                {title}
            </h3>
            {description && (
                <p
                    className={cn(
                        'mt-1 text-muted-foreground leading-5',
                        level === 'page'
                            ? 'text-base'
                            : 'text-(length:--fs-title-compact)'
                    )}
                >
                    {description}
                </p>
            )}
        </div>
        {action}
    </div>
);
